import React, { useContext } from 'react';
import { Badge } from 'antd';

import CommissioningReportContext from '@totem/components/salesOrders/commissioning/CommissioningReportContext';
import CommissioningReportFilters from '@totem/components/salesOrders/commissioning/CommissioningReportFilters';
import CommissioningReportTable from '@totem/components/salesOrders/commissioning/CommissioningReportTable';

export const CommissioningReportExtra = () => {
  const { totalRecords } = useContext(CommissioningReportContext);

  return (
    <Badge count={totalRecords} overflowCount={9999} offset={[0, -7]}>
      Services Not Delivered&nbsp;&nbsp;
    </Badge>
  );
};

const CommissioningReportLayout = () => (
  <>
    <CommissioningReportFilters />
    <CommissioningReportTable />
  </>
);

export default CommissioningReportLayout;
